import { useInfiniteQuery } from "react-query";
import axios from "infra/http";
import { ConsumoQueryParams, ConsumoUnidade } from "../typings";
import { PaginateResult } from "core/resources/types/shared";

function useConsumoUnidadesInfiniteScroll(
  consumoId?: string,
  params?: ConsumoQueryParams & { consumoAnteriorId?: string | null }
) {
  return useInfiniteQuery(
    [`/v1/consumo/${consumoId}/unidades`, params],
    async ({ pageParam }) => {
      const { data } = await axios.get<PaginateResult<ConsumoUnidade>>(
        `/v1/consumo/${consumoId}/unidades`,
        {
          params: {
            ...params,
            page: pageParam,
          },
        }
      );

      return data;
    },
    {
      enabled: !!consumoId,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.items.length < 0 ? undefined : allPages.length + 1,
    }
  );
}

export default useConsumoUnidadesInfiniteScroll;
